import { render, staticRenderFns } from "./announcementPreviewer.vue?vue&type=template&id=e008f0b8&scoped=true"
import script from "./announcementPreviewer.vue?vue&type=script&lang=js"
export * from "./announcementPreviewer.vue?vue&type=script&lang=js"
import style0 from "./announcementPreviewer.vue?vue&type=style&index=0&id=e008f0b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e008f0b8",
  null
  
)

export default component.exports